<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.5,6C12.29,6,11.28,6.859999999999999,11.05,8C11.05,8,9.75,8,9.75,8C9.75,8,5.74,4,5.74,4C5.74,4,4.99,4.75,4.99,4.75C4.99,4.75,8.25,8,8.25,8C8.25,8,4.95,8,4.95,8C4.72,6.859999999999999,3.71,6,2.5,6C1.12,6,0,7.12,0,8.5C0,9.879999999999999,1.12,11,2.5,11C3.71,11,4.72,10.14,4.95,9C4.95,9,8.25,9,8.25,9C8.25,9,4.99,12.25,4.99,12.25C4.99,12.25,5.74,13,5.74,13C5.74,13,9.75,9,9.75,9C9.75,9,11.05,9,11.05,9C11.28,10.14,12.29,11,13.5,11C14.88,11,16,9.879999999999999,16,8.5C16,7.12,14.88,6,13.5,6C13.5,6,13.5,6,13.5,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Flows',
} as DefineComponent
</script>
